<template>
    <div v-if="feature && feature.early_access">
        <simple-dropdown activate-on-hover without-chevron>
            <template #trigger>
                <div class="bg-semantic-warning rounded-6 shadow-lg px-8 py-4 text-white font-semibold text-body-sm select-none uppercase"
                     :class="badgeClass">
                    {{ $t('features.early_access.title') }}
                </div>
            </template>
            <template #content>
                <div class="bg-white py-8 px-12 shadow rounded-6 flex-none w-480">
                    <p class="font-semibold">{{ $t('features.early_access.warning') }}</p>
                    <p class="mt-8" v-html="feature.description[locale]"></p>
                    <p class="mt-8 cursor-pointer hover:text-secondary trans-ease" @click="talkToUs">
                        👉 {{ $t('features.early_access.feedback') }}
                    </p>
                </div>
            </template>
        </simple-dropdown>
    </div>
</template>

<script>
import {mapState, mapActions} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../state/store';
import Feature from "../models/Feature";
import SimpleDropdown from "./ui/SimpleDropdown";

export default {
    components: {SimpleDropdown},
    props: {
        featureKey: String,
        badgeClass: String
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany', 'locale']),
        feature() {
            return useRepo(Feature)
                .where('key', this.featureKey)
                .first();
        }
    },
    methods: {
        talkToUs() {
            window.HubSpotConversations.widget.open();
        }
    }
}
</script>
